import * as Yup from 'yup';

const ModalFiscaSchema = Yup.object().shape({
  document_number: Yup.string().required('O campo CPF/CNPJ é obrigatório'),
  address_zip_code: Yup.string().length(8, 'Formato do CEP inválido').required('O campo CEP é obrigatório'),
  address_street: Yup.string().required('O campo endereço é obrigatório'),
  address_neighborhood: Yup.string().required('O campo bairro é obrigatório'),
  address_state: Yup.string().required('O campo estado é obrigatório'),
  address_number: Yup.string().required('O campo número é obrigatório'),
  address_city_name: Yup.string().required('O campo cidade é obrigatório'),
  fiscal_responsibility: Yup.boolean().required('O campo termos fiscais é obrigatório').oneOf([true], 'O campo termos fiscais é obrigatório'),
  producer_affiliate_terms: Yup.boolean().required('O campo termos fiscais é obrigatório').oneOf([true], 'O campo termos de uso é obrigatório'),
});

export default ModalFiscaSchema;
